var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-image"},[_c('CMSImage',{attrs:{"image":_vm.image,"width":_vm.width || 1920}}),(_vm.attribution)?_c('div',{staticClass:"image-credit"},[_vm._v(_vm._s(_vm.attribution))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }